import React from 'react'
import {useParams} from 'react-router-dom'
import useStateObject from 'admin/hooks/useStateObject'
import useTextMessage from 'admin/hooks/useTextMessage'
import InputField from 'admin/components/shared/InputField'
import {pluralise} from 'admin/lib/format'
import {compact} from 'lodash'
import Header from '../shared/Header'
import Modal from '../shared/Modal'
import useModal from '../../hooks/useModal'
import useOrganisation from '../../hooks/useOrganisation'

export default () => {
  const {organisationID} = useParams()
  const {organisation} = useOrganisation(organisationID)
  const {groupIds = '', accountIds = '', popModal} = useModal()
  const {errors, create} = useTextMessage(organisationID)
  const [form, setForm, resetForm] = useStateObject({contentWithPlaceholders: ''})

  const fullMessage = `${organisation?.externalName?.toUpperCase()}: ${form.contentWithPlaceholders}\nDoNotReply. SMS&DataRatesApply`
  const parsedGroupIds = groupIds.length ? groupIds.split(',') : []
  const parsedAccountIds = accountIds.length ? accountIds.split(',') : []

  const handleCreate = e => {
    create(
      {
        accountIds: parsedAccountIds,
        groupIds: parsedGroupIds,
        contentWithPlaceholders: fullMessage
      },
      () => handleClose(e)
    )
  }

  const handleClose = e => {
    e.preventDefault()
    resetForm()
    popModal('new-text-message', ['groupIds', 'accountIds'])
  }

  return (
    <Modal onClose={handleClose} flashId='new-text-message'>
      <Header title='New text message'>
        <button className='button is-primary' onClick={handleCreate}>
          Send to{' '}
          {compact([
            parsedAccountIds.length ? pluralise('selected account', parsedAccountIds.length, true) : '',
            parsedGroupIds.length ? pluralise('selected group', parsedGroupIds.length, true) : ''
          ]).join(' and ')}
        </button>
      </Header>
      <section className='section'>
        <div className='container content is-size-7'>
          Please note:
          <ul>
            <li>Only active accounts with valid mobile numbers will be included</li>
            <li>Accounts with multiple mobile numbers will receive a message to each mobile number</li>
          </ul>
        </div>
        <div className='columns'>
          <div className='column is-half'>
            <label className='label is-small'>Preview</label>
            <div
              className='box has-linebreaks has-text-weight-medium has-background-filters is-shadowless'
              style={{marginBottom: '0', overflowWrap: 'break-word'}}>
              {fullMessage}
            </div>
            <span className='help has-text-right'>
              {fullMessage.length} characters. {pluralise('message part', Math.ceil(fullMessage.length / 160), true)}.
            </span>
          </div>
          <div className='column is-half'>
            <form>
              <div className='field'>
                <div className='control'>
                  <InputField
                    type='textarea'
                    name='contentWithPlaceholders'
                    label='Message'
                    rows={5}
                    errors={errors.contentWithPlaceholders}
                    value={form.contentWithPlaceholders}
                    onChange={setForm}
                    help={
                      <span>
                        Refer to the{' '}
                        <a href='https://www.dia.govt.nz/spam' target='_blank'>
                          Department of Internal Affairs website
                        </a>{' '}
                        for electronic message regulations.
                      </span>
                    }
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </Modal>
  )
}
